export const editListingUploadedImages = new Map();
